import React, { useEffect, useState } from 'react';
import {
  Box,
  Grid, IconButton, MenuItem, TextField, Tooltip, Typography,
} from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import { HtmlTooltip } from 'components/tooltips/HtmlTootip';
import { Field, getIn } from 'formik';
import {
  POND_STATUS,
  pondTypes, productionSystem, workProtocol,
} from 'utils/consts';
import NumberFormat from 'react-number-format';
import { ReactComponent as Trash } from '../../../../images/icons/trash.svg';
import { checkPondType, labelField } from 'utils';
import api from 'services/api';

function InputGroup({
  index, onRemove, disableRemoveButton, item, descriptionPonds, recoverPond, setValues, existsId, checkIfcopy,
}) {
  const [hasPondWithThisDescription, setHasPondWithThisDescription] = useState(false);
  const [isDuplicatePondName, setIsDuplicatePondName] = useState(false);

  useEffect(() => {
    if (existsId && recoverPond) {
      let data = recoverPond;
      if (checkIfcopy) {
        data = { ...recoverPond, id: null };
      }

      const ponds = [
        {
          ...data,
          depth: parseFloat(recoverPond.depth) || null,
        },
      ];
      setValues({ ponds });
    }
  }, [checkIfcopy, existsId, recoverPond, setValues]);

  async function hasPond(description) {
    setTimeout(async () => {
      const { data } = await api.get(
        `/ponds/description/${description.trim()}`,
      );

      return data
        ? setHasPondWithThisDescription(true)
        : setHasPondWithThisDescription(false);
    }, 200);
  }

  const hasDuplicatedPondName = (value) => {
    const result = descriptionPonds.some((description) => description === value);
    setIsDuplicatePondName(result);
  };

  return (
    <Box display="flex" gap={2}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Field name={`ponds.${index}.description`}>
            {({ field, form }) => {
              const touched = getIn(form.touched, `ponds.${index}.description`);
              const errors = getIn(form.errors, `ponds.${index}.description`);

              const message = hasPondWithThisDescription ? 'Viveiro físico existente!' : null;
              const messageDuplicate = !message && isDuplicatePondName ? 'Insira um nome que não esteja repetido!' : null;

              return (
                <TextField
                  {...field}
                  fullWidth
                  inputProps={{ maxLength: 50 }}
                  id="description"
                  label={labelField('Nome')}
                  variant="outlined"
                  name="description"
                  type="text"
                  onChange={(event) => {
                    hasPond(event.target.value);
                    hasDuplicatedPondName(event.target.value);
                    form.setFieldValue(field.name, event.target.value);
                  }}
                  onBlur={() => form.setFieldTouched(field.name, true)}
                  error={(touched && errors) || hasPondWithThisDescription || isDuplicatePondName}
                  helperText={(touched && errors) || message || messageDuplicate}
                />
              );
            }}
          </Field>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Field name={`ponds.${index}.status`}>
            {({ field, form }) => {
              const touched = getIn(form.touched, `ponds.${index}.status`);
              const errors = getIn(form.errors, `ponds.${index}.status`);
              return (
                <TextField
                  {...field}
                  fullWidth
                  InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                  select
                  label={labelField('Status')}
                  onBlur={() => form.setFieldTouched(field.name, true)}
                  variant="outlined"
                  error={touched && errors}
                  helperText={touched && errors}
                >
                  <MenuItem key={1} value={POND_STATUS.DISPONIVEL}>
                    {POND_STATUS.DISPONIVEL}
                  </MenuItem>
                  <MenuItem key={2} value={POND_STATUS.MANUTENCAO}>
                    {POND_STATUS.MANUTENCAO}
                  </MenuItem>
                </TextField>
              );
            }}
          </Field>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Field name={`ponds.${index}.type`}>
            {({ field, form }) => {
              const touched = getIn(form.touched, `ponds.${index}.type`);
              const errors = getIn(form.errors, `ponds.${index}.type`);
              return (
                <TextField
                  {...field}
                  fullWidth
                  InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                  select
                  label={(
                    <div>
                      {labelField('Tipo')}
                      {' '}
                      <HtmlTooltip
                        title="Escolha o tipo de viveiro que se adequa ao que
                      está sendo criado"
                        placement="right"
                        arrow
                      >
                        <HelpIcon color="primary" fontSize="inherit" />
                      </HtmlTooltip>
                    </div>
                )}
                  onChange={(event) => {
                    if (!checkPondType(event.target.value)) {
                      form.setFieldValue(`ponds.${index}.depth`, null);
                    }
                    form.handleChange(event);
                  }}
                  onBlur={() => form.setFieldTouched(field.name, true)}
                  variant="outlined"
                  error={touched && errors}
                  helperText={touched && errors}
                >
                  {pondTypes.map(({ key, value }) => (
                    <MenuItem key={key} value={value}>
                      {value}
                    </MenuItem>
                  ))}
                </TextField>
              );
            }}
          </Field>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Field name={`ponds.${index}.capacity`}>
            {({ field, form }) => {
              const touched = getIn(form.touched, `ponds.${index}.capacity`);
              const errors = getIn(form.errors, `ponds.${index}.capacity`);

              return (
                <NumberFormat
                  value={field.value}
                  fullWidth
                  inputProps={{ maxLength: 6 }}
                  InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                  label={labelField('Área (m²)')}
                  variant="outlined"
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  onValueChange={(values) => {
                    form.setFieldValue(field.name, values.floatValue);
                  }}
                  onBlur={() => form.setFieldTouched(field.name, true)}
                  customInput={TextField}
                  error={touched && errors}
                  helperText={touched && errors}
                />
              );
            }}
          </Field>
        </Grid>
        {checkPondType(item.type) && (
        <Grid item xs={12} sm={3}>
          <Field name={`ponds.${index}.depth`}>
            {({ field, form }) => {
              const touched = getIn(form.touched, `ponds.${index}.depth`);
              const errors = getIn(form.errors, `ponds.${index}.depth`);
              return (
                <NumberFormat
                  value={field.value}
                  fullWidth
                  inputProps={{ maxLength: 6 }}
                  InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                  label={labelField('Profundidade (m)')}
                  variant="outlined"
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  onValueChange={(values) => {
                    form.setFieldValue(field.name, values.floatValue);
                  }}
                  onBlur={() => form.setFieldTouched(field.name, true)}
                  customInput={TextField}
                  error={touched && errors}
                  helperText={touched && errors}
                />
              );
            }}
          </Field>
        </Grid>
        )}
        <Grid item xs>
          <Field name={`ponds.${index}.system`}>
            {({ field, form }) => {
              const touched = getIn(form.touched, `ponds.${index}.system`);
              const errors = getIn(form.errors, `ponds.${index}.system`);
              return (
                <TextField
                  {...field}
                  fullWidth
                  InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                  select
                  label={labelField('Sistema de produção', 'Tipo de sistema de produção utilizado')}
                  onBlur={() => form.setFieldTouched(field.name, true)}
                  variant="outlined"
                  error={touched && errors}
                  helperText={touched && errors}
                >
                  {productionSystem.map(({ key, value }) => (
                    <MenuItem key={key} value={value}>
                      {value}
                    </MenuItem>
                  ))}
                </TextField>
              );
            }}
          </Field>
        </Grid>
        <Grid item xs>
          <Field name={`ponds.${index}.protocol`}>
            {({ field, form }) => {
              const touched = getIn(form.touched, `ponds.${index}.protocol`);
              const errors = getIn(form.errors, `ponds.${index}.protocol`);
              return (
                <TextField
                  {...field}
                  fullWidth
                  InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                  select
                  label={labelField('Protocolo de trabalho', 'Protocolo usado no sistema de produção (Opcional)')}
                  onBlur={() => form.setFieldTouched(field.name, true)}
                  variant="outlined"
                  error={touched && errors}
                  helperText={touched && errors}
                >
                  {workProtocol.map(({ key, value }) => (
                    <MenuItem key={key} value={value}>
                      {value}
                    </MenuItem>
                  ))}
                </TextField>
              );
            }}
          </Field>
        </Grid>
      </Grid>
      {!existsId && (
        <Grid
          item
          xs="auto"
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
        >
          <Tooltip title="Remover">
            <IconButton disabled={disableRemoveButton || index === 0} onClick={onRemove}>
              <Trash opacity={(disableRemoveButton || index === 0) && 0} />
            </IconButton>
          </Tooltip>
        </Grid>
      )}
    </Box>

  );
}

export default InputGroup;
